import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { QuerySvipRightsProps } from '@/views/user/member/service';

const SVIPRIGHTS_KEY = 'React-ts-ant-svipRights';

const localSvipRights = LocalStore.getValue<QuerySvipRightsProps>(SVIPRIGHTS_KEY) || {};

export const defaults: QuerySvipRightsProps = {
  growthValue: 0,
  levelGrowthValue: [],
  rightConf: [],
  svipLevel: 0,
  svipLevelCount: 0,
  ...localSvipRights
};

const SVIP_RIGHTS_KEY = 'React-ts-ant-SVIPRIGHTS';

export const updateSvipRights: (svipRights: QuerySvipRightsProps) => IAction<QuerySvipRightsProps> = (
  svipRights: QuerySvipRightsProps
) => ({
  type: SVIP_RIGHTS_KEY,
  payload: svipRights
});

const svipRightsReducer: Reducer<QuerySvipRightsProps, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case SVIP_RIGHTS_KEY:
      LocalStore.setValue(SVIPRIGHTS_KEY, payload as QuerySvipRightsProps);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default svipRightsReducer;
